<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { showToast } from '../lib/toast';

  export let isOpen = false;
  export let shareLink = '';
  export let onClose: () => void;

  // Check if the browser supports the Web Share API
  function isShareAvailable(): boolean {
    return Boolean(navigator.share && navigator.canShare);
  }

  async function shareLink_() {
    try {
      if (isShareAvailable()) {
        await navigator.share({
          title: $_('scoreBoard.shareTitle'),
          text: $_('scoreBoard.shareText'),
          url: shareLink
        });
      } else {
        // Fallback for browsers that don't support sharing
        await copyToClipboard();
      }
    } catch (error) {
      console.error('Error sharing link:', error);
      // Fallback to copy if sharing fails
      await copyToClipboard();
    }
  }

  async function copyToClipboard() {
    try {
      await navigator.clipboard.writeText(shareLink);
      showToast($_('common.copiedToClipboard'), 'success');
    } catch (error) {
      // Fallback for older browsers
      const textarea = document.createElement('textarea');
      textarea.value = shareLink;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      showToast($_('common.copiedToClipboard'), 'success');
    }
  }
</script>

{#if isOpen}
<dialog class="z-2000" open>
  <article>
    <header>
      <h3>{$_('scoreBoard.shareTitle')}</h3>
      <button aria-label="Close" class="close" on:click={onClose}></button>
    </header>

    <div class="share-content">
      <p>{$_('scoreBoard.shareDescription')}</p>

      <div class="link-container">
        <input
          type="text"
          readonly
          value={shareLink}
          class="share-link"
        />
      </div>

    </div>

    <footer class="">
      <button type="button" class="success full-width" on:click={shareLink_}>
        <ion-icon name="share-outline"></ion-icon>
        {isShareAvailable() ? $_('scoreBoard.shareButton') : $_('scoreBoard.copyButton')}
      </button>
    </footer>
  </article>
</dialog>
{/if}

<style>
  .z-2000 {
    z-index: 2000;
  }

  .share-content {
    margin: 1rem 0;
  }

  .link-container {
    margin: 1rem 0;
  }

  .share-link {
    width: 100%;
    font-family: monospace;
    font-size: 0.875rem;
    background-color: var(--pico-background-color);
    border: 1px solid var(--pico-border-color);
    padding: 0.75rem;
    border-radius: 4px;
    cursor: text;
  }

  .share-link:focus {
    outline: 2px solid var(--pico-primary);
    outline-offset: 2px;
  }

  footer {
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
    margin-top: 1.5rem;
  }

  footer button {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  footer button ion-icon {
    font-size: 1rem;
  }
</style>
